export function checkHasSameKeys(
  obj1: Record<string, unknown>,
  obj2: Record<string, unknown>,
  options?: Partial<{ deep: boolean }>
): boolean {
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)

  // First check if top-level keys match
  const hasMatchingKeys =
    keys1.length === keys2.length && keys1.every((key) => keys2.includes(key))

  // If shallow comparison is requested or keys don't match, return early
  if (!options?.deep || !hasMatchingKeys) {
    return hasMatchingKeys
  }

  // For deep comparison, recursively check nested objects
  return keys1.every((key) => {
    const val1 = obj1[key]
    const val2 = obj2[key]

    // If both values are objects (but not null), recursively compare their keys
    if (
      val1 &&
      val2 &&
      typeof val1 === 'object' &&
      typeof val2 === 'object' &&
      !Array.isArray(val1) &&
      !Array.isArray(val2)
    ) {
      return checkHasSameKeys(
        val1 as Record<string, unknown>,
        val2 as Record<string, unknown>,
        options
      )
    }

    // If values aren't both objects, we only care that the keys match (which we already checked)
    return true
  })
}
